export default __webpack_public_path__ + "static/media/logo_volumio.680e3395.png";